import { IPosition, IContact } from '@nkr/models/index';
import { plusSquare } from 'react-icons-kit/fa/plusSquare';
import { minusSquare } from 'react-icons-kit/fa/minusSquare';
import { warning } from 'react-icons-kit/fa/warning';
import Icon from 'react-icons-kit';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';

interface IProps {
    index: number,
    position: IPosition,
    isExpanded: boolean,
    staffList: IContact[],
    onExpand: (positionNumber: number) => void,
    onOpenLogistics: (chainId: number, clusterNumer: number, positionNumber: number) => void,
    onOpenOptions: (chainId: number, clusterNumer: number, positionNumber: number) => void,
}

const PositionListRow = (props: IProps) => {
    const handleExpandPosition = (e: any) => {
        e.stopPropagation();
        props.onExpand(props.index);
    };

    const handleOpenLogistics = () => {
        let { chainId, clusterNumber, positionNumber } = props.position;
        props.onOpenLogistics(chainId, clusterNumber, positionNumber);
    };

    const handleOpenCustomLogistics = (e: any) => {
        e.stopPropagation();
        let { chainId, clusterNumber, positionNumber } = props.position;
        props.onOpenOptions(chainId, clusterNumber, positionNumber);
    };

    const getCustomLogisticsIndicatorStyle = (): { color: string, title: string } => {
        switch (props.position.customLogisticsStatus) {
            case 1: // tan
                return { color: 'purple', title: 'Existing draft options' };

            case 2: // blue
            case 3:
                return { color: '#4f82e0', title: 'Options submitted to NKR' };

            case 4: // amber
                return { color: '#e0a44f', title: 'Options submitted to Center' };

            case 5: // green
                return { color: '#64b06b', title: 'Option selected by Center' };
        }

        return { color: '#a2a5a6', title: 'No options' };
    };

    const { position, isExpanded } = props;
    const { donor, recipient } = position;
    const customLogisticsIndicatorStyle = getCustomLogisticsIndicatorStyle();

    const swapManagerOverlay = (
        <Popover>
            <div>{position.swapManager ? position.swapManager.name : ''}</div>
            <div>{position.swapManager ? position.swapManager.phoneNumber : ''}</div>
            <div>{position.swapManager ? position.swapManager.email : ''}</div>
        </Popover>
    );


    const donorTimezone = donor.center.timezone;
    const flightDepartureTimeTz = donor.logistics.flightDepartureTimeTz ? donor.logistics.flightDepartureTimeTz : donorTimezone;

    const recipientTimezone = recipient.center.timezone;
    const flightArrivalTimeTz = donor.logistics.flightArrivalTimeTz ? donor.logistics.flightArrivalTimeTz : recipientTimezone;

    return (
        <tr onClick={handleOpenLogistics}>
            <td style={{ color: customLogisticsIndicatorStyle.color }} title={customLogisticsIndicatorStyle.title}>
                <Icon
                    icon={warning}
                    onClick={handleOpenCustomLogistics} />
            </td>
            <td>
                <Icon
                    icon={isExpanded ? minusSquare : plusSquare}
                    onClick={handleExpandPosition} />
            </td>
            <td>{position.positionNumber}</td>
            <td>
                {position.swapManager && (
                    <OverlayTrigger trigger='click' overlay={swapManagerOverlay} rootClose>
                        <Button bsSize='xs' onClick={(e: any) => e.stopPropagation()}>{position.swapManager.initials}</Button>
                    </OverlayTrigger>
                )}
            </td>

            <td>
                {donor.center.alias}
                {donor.rdnCenterId > 0 && donor.rdnCenterId != donor.center.id ? <>(<span style={{ color: 'red' }}>{donor.rdnCenterAlias}</span>) </> : null}
            </td>
            <td>{donor.alias} ({position.donor.unosId})</td>
            <td>{donor.logistics.kidneyPickupDateTime} {donor.center.timezone}</td>
            <td>{donor.logistics.flightRouteOrGround}</td>
            <td>{donor.logistics.flightCarrierAndNumber}</td>
            <td>{donor.logistics.flightDepartureTime} {donor.logistics.flightDepartureTime != '' ? flightDepartureTimeTz : ''}</td>
            <td>{donor.logistics.flightArrivalTime} {donor.logistics.flightArrivalTime != '' ? flightArrivalTimeTz : ''}</td>
            <td>{donor.logistics.kidneyArrivalDateTime} {recipient.center.timezone}</td>

            <td>{recipient.center.alias}</td>
            <td>{recipient.alias}</td>
            <td>{recipient.logisticsProviderName}</td>
            <td>{recipient.courierJobNumber}</td>
        </tr>
    );
}

export default PositionListRow;